/* manager meta tags in header */

export default (meta: any) => {
  /* update meta title */
  if (meta.title) {
    const titleElm = document.head.querySelector('title');
    titleElm && (titleElm.innerText = `intrabuild ${meta.title}`);
  }
};
